import {app} from "../firebase";
import { getFunctions } from 'firebase/functions';
import { useHttpsCallable } from 'react-firebase-hooks/functions';
export default function useFirebaseFunction(name, region) {
	return useHttpsCallable(
		getFunctions(app, region),
		name
	)
}
